module.exports = __webpack_public_path__ + "assets/media/evening.f7c6d05c.mp3";